<div>
  <input #PhoneNumber
    id="PhoneNumber"
    type="text"
    autocomplete="off"
    [name]="name"
    [formControl]="control"
    (input)="onPhoneNumberChange($event)"
    [required]="inputRequired"
    [ngClass]="cssClass"
    [readonly]= "isReadonly"
    maxlength="32"
    style="border-style: solid !important; border-width: 1px !important;"
  />
</div>
